/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {NgModule} from "@angular/core";

import {ClubcolorPipe} from "./clubcolor.pipe";
import {AigAuthcolorPipe} from "./aig-authcolor.pipe";
import {AIGAuthisPipe} from "./aig-authis.pipe";
import {AigTypecolorPipe} from "./aig-typecolor.pipe";

@NgModule({
	declarations: [
		ClubcolorPipe,
		AigAuthcolorPipe,
		AigTypecolorPipe,
		AIGAuthisPipe,
	],
	imports: [],
	exports: [
		ClubcolorPipe,
		AigAuthcolorPipe,
		AigTypecolorPipe,
		AIGAuthisPipe,
	],
	providers: [],
	bootstrap: [],
})

export class AigPipeModule {

}
